import type { AlertProps } from "@mui/material";

type NotifyFn = (message: string, severity?: AlertProps["severity"]) => void;

// Holds the live notify() from NotificationProvider so non-React modules (the
// API client in common/utils/Api.tsx) can surface a message — e.g. blocking a
// write while offline. NotificationProvider registers/clears this on mount.
let currentNotify: NotifyFn | undefined;

export function setGlobalNotify(fn: NotifyFn | undefined): void {
  currentNotify = fn;
}

export function globalNotify(
  message: string,
  severity?: AlertProps["severity"]
): void {
  currentNotify?.(message, severity);
}
